import { render } from "./Proof.vue?vue&type=template&id=6d453271&scoped=true"
import script from "./Proof.vue?vue&type=script&lang=js"
export * from "./Proof.vue?vue&type=script&lang=js"

import "./Proof.vue?vue&type=style&index=0&id=6d453271&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d453271"

export default script